import React, { useEffect, useState } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { FieldContainer } from '@atlassian/jira-issue-create-commons/src/common/ui/fields/styled.tsx';
import CommonTimeTrackingField from '@atlassian/jira-issue-create-commons/src/ui/time-tracking-field/index.tsx';
import { useFormContext } from '@atlassian/jira-issue-create-form-context/src/index.tsx';
import secondsToTimeString from '@atlassian/jira-issue-view-common-utils/src/time-string/seconds-to-time-string/index.tsx';
import messages from './messages.tsx';
import type { Props } from './types.tsx';

const TimeTrackingField = (props: Props) => {
	// the reason we are transforming the default value here instead of options object in the with form field wrapper is because time tracking settings also need to be passed to transform the default value. Right now, there is no way to pass props to the generic transformDefaultValue invocation in with form field
	const [transformedDefaultValue, setTransformedDefaultValue] = useState<string | undefined>(
		undefined,
	);
	const {
		defaultValue,
		additionalData: { timeTrackingSettings },
		width = 350,
		isMini,
		isFieldResponsive,
	} = props;

	useEffect(() => {
		if (typeof defaultValue === 'string') {
			setTransformedDefaultValue(defaultValue.trim());
		} else if (defaultValue?.timeInSeconds) {
			setTransformedDefaultValue(
				secondsToTimeString(
					timeTrackingSettings.daysPerWeek,
					timeTrackingSettings.hoursPerDay,
				)(defaultValue.timeInSeconds),
			);
		}
	}, [defaultValue, timeTrackingSettings.hoursPerDay, timeTrackingSettings.daysPerWeek]);

	const [, { setTimeTrackingValue }] = useFormContext();
	const { formatMessage } = useIntl();

	const shouldSetWidth = isMini || isFieldResponsive;

	return (
		<FieldContainer width={shouldSetWidth ? '100%' : width}>
			<CommonTimeTrackingField
				{...props}
				fieldName={formatMessage(messages.timeTrackingFieldName)}
				defaultValue={transformedDefaultValue}
				setValueExternal={setTimeTrackingValue}
			/>
		</FieldContainer>
	);
};

export default TimeTrackingField;
